import { TranslationsContext } from "@teliaee/telia-translate";
import React from "react";
import { AnalyticsTrigger, Modal, ModalContent, Notice, Text, Button } from "telia-front-react";
const SuccessModal = (props) => {
  const { translate } = React.useContext(TranslationsContext);
  const { onCloseCallback } = props;
  return /* @__PURE__ */ React.createElement(AnalyticsTrigger, { trigger: { id: "Modal - validate-information-success-close", callback: "onClose" } }, /* @__PURE__ */ React.createElement(
    Modal,
    {
      isOpen: true,
      hasContentComponent: true,
      size: "6-col",
      isClosable: true,
      closeButtonLabel: translate("common.success.close"),
      onClose: onCloseCallback
    },
    /* @__PURE__ */ React.createElement(ModalContent, null, /* @__PURE__ */ React.createElement(Notice, { type: "success", direction: "vertical" }, /* @__PURE__ */ React.createElement(Text, null, /* @__PURE__ */ React.createElement("p", { className: "h3" }, translate("common.success.heading")), /* @__PURE__ */ React.createElement("p", { className: "text__margin-double" }, translate("common.success.body")), /* @__PURE__ */ React.createElement(Button, { text: translate("common.success.close"), variant: "secondary", onClick: onCloseCallback }))))
  ));
};
export {
  SuccessModal as default
};
